import { render, staticRenderFns } from "./project-card.vue?vue&type=template&id=4111f370&scoped=true&"
import script from "./project-card.vue?vue&type=script&lang=js&"
export * from "./project-card.vue?vue&type=script&lang=js&"
import style0 from "./project-card.vue?vue&type=style&index=0&id=4111f370&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4111f370",
  null
  
)

export default component.exports